





































import { Component, Vue } from 'vue-property-decorator'
import { queryDictsByCode, addTopic } from '@/api/api'
import axios from 'axios'
// import qs from 'qs'
var E = require('wangeditor')

@Component({
  components: {}
})
export default class PublishTopic extends Vue {
  topicTypeList: Array<object> = [] // 类型列表
  editor: any = '' // 富文本编辑器
  imgPath: string = '' // 题图本地路径
  imgUrl: string = '' // 题图网络路径
  topicType: string = 'talk' // 类型
  title: string = '' // 标题

  mounted() {
    this._queryDictsByCode()

    // 创建富文本编辑器
    const editor = new E('#editor')
    editor.customConfig.menus = [
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'strikeThrough', // 删除线
      'foreColor', // 文字颜色
      'backColor', // 背景颜色
      'justify', // 对齐方式
      'quote', // 引用
      'table', // 表格
      'undo', // 撤销
      'redo' // 重复
    ]
    // editor.customConfig.pasteFilterStyle = false
    editor.create()
    this.editor = editor
  }

  // 上传图片限制
  beforeImgUpload(file: any) {
    let type = file.type.split('/')[0]
    const isImg = type === 'image'
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isImg) {
      this.$message.warning('图片格式不正确!')
    }
    if (!isLt2M) {
      this.$message.warning('上传图片大小不能大于 2MB!')
    }
    return isImg && isLt2M
  }

  /**
   * 图片上传
   */
  httpRequest(options: any) {
    const vm = this
    let file = options.file
    let filename = file.name
    const fileType = options.file.name.split('.')[1]
    const reader = new FileReader()
    if (file) {
      reader.readAsDataURL(file)
    }
    reader.onload = () => {
      let base64Str: any = reader.result
      let config: any = {
        url: '/api/file/uploadFile',
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: window.localStorage.getItem('userToken')
        },
        // file: file,
        data: {
          file: base64Str.split(',')[1],
          file_type: fileType
        },
        timeout: 10000,
        onUploadProgress: function(progressEvent: any) {
          // console.log(progressEvent)
          progressEvent.percent = (progressEvent.loaded / progressEvent.total) * 100
          options.onProgress(progressEvent, file)
        }
      }

      const loading = this.$loading({
        lock: true,
        text: '上传图片中',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios(config)
        .then((res: any) => {
          loading.close()
          if (res.data.code === 101) {
            options.onSuccess(res, file)
            vm.imgPath = res.data.result.file_path
            vm.imgUrl = res.data.result.file_links
            console.log('success')
          }
        })
        .catch((err: any) => {
          loading.close()
          options.onError(err)
        })
    }
  }

  /**
   * 返回看点页
   */
  back(): void {
    this.$emit('onBack', '0')
  }

  /**
   * 提交
   */
  submit(): void {
    let check = false

    // title_img: this.imgPath,
    //   type_code: this.topicType,
    //   topic_name: this.title,
    //   topic_context: this.editor.txt.html()

    if (!this.imgPath) {
      this.$message.warning('请上传题图')
    } else if (!this.topicType) {
      this.$message.warning('请选择话题类型')
    } else if (!this.title) {
      this.$message.warning('请填写标题')
    } else {
      check = true
    }

    if (check) {
      this._addTopic()
    }
  }

  /**
   * 获取看点类型
   */
  _queryDictsByCode(): void {
    queryDictsByCode({
      parent_code: 'topic'
    }).then((res: any) => {
      this.topicTypeList = res.data.result
    })
  }

  /**
   * 添加话题看点
   * @param title_img     题图路径
   * @param type_code     话题类型
   * @param topic_name    标题
   * @param topic_context 正文
   */
  _addTopic(): void {
    const load = this.$loading({
      lock: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    addTopic({
      title_img: this.imgPath,
      type_code: this.topicType,
      topic_name: this.title,
      topic_context: this.editor.txt.html()
    }).then((res: any) => {
      load.close()
      if (res.data.code === 101) {
        this.$message.success('提交成功')
        this.$emit('success')
      }
    })
  }
}
